// Auto-generated phoneme to filename mapping
export const phonemeToFilename: { [key: string]: string } = {
  "ə": "schwa.mp3",
  "aː": "aa_long.mp3",
  "ɪ": "i_short.mp3",
  "iː": "ii_long.mp3",
  "ʊ": "u_short.mp3",
  "uː": "uu_long.mp3",
  "eː": "e_long.mp3",
  "ɛː": "ai_long.mp3",
  "oː": "o_long.mp3",
  "ɔː": "au_long.mp3",
  "k": "ka.mp3",
  "g": "ga.mp3",
  "tʃ": "cha.mp3",
  "dʒ": "ja.mp3",
  "ʈ": "ta_retroflex.mp3",
  "ɖ": "da_retroflex.mp3",
  "t̪": "ta_dental.mp3",
  "d̪": "da_dental.mp3",
  "p": "pa.mp3",
  "b": "ba.mp3",
  "kʰ": "kha.mp3",
  "gʱ": "gha.mp3",
  "tʃʰ": "chha.mp3",
  "dʒʱ": "jha.mp3",
  "ʈʰ": "tha_retroflex.mp3",
  "ɖʱ": "dha_retroflex.mp3",
  "t̪ʰ": "tha_dental.mp3",
  "d̪ʱ": "dha_dental.mp3",
  "pʰ": "pha.mp3",
  "bʱ": "bha.mp3",
  "ŋ": "nga.mp3",
  "ɲ": "nya.mp3",
  "ɳ": "na_retroflex.mp3",
  "n": "na.mp3",
  "m": "ma.mp3",
  "j": "ya.mp3",
  "r": "ra.mp3",
  "l": "la.mp3",
  "ʋ": "va.mp3",
  "ʃ": "sha.mp3",
  "ʂ": "sha_retroflex.mp3",
  "s": "sa.mp3",
  "h": "ha.mp3",
  "ɽ": "da_flap.mp3",
  "ɽʱ": "dha_flap.mp3"
};
